import { store } from 'v3/data/store';
import { VoucherStatusEnum } from 'v3/shared/enums/voucher-status.enum';
import { voucherSlice } from '.';
import { IVoucher } from './types';

export const setVoucher = (voucher: IVoucher) => {
  store.dispatch(voucherSlice.actions.setVoucher(voucher));
};

export const setVoucherStatus = (status: VoucherStatusEnum) => {
  store.dispatch(voucherSlice.actions.setVoucherStatus(status));
};

export const clearVoucherStatus = () => {
  store.dispatch(voucherSlice.actions.clearVoucherStatus());
};
